import { mapValues } from 'lodash';
/**
 * Version 36 migration - Adding tax refund mapping
 */
export default function v36(website) {
  return {
    ...website,
    eventVersion: 36,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'RegistrationCancellationRefund') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              additionalItems: {
                styleMapping: 'body1'
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
